define("shared/utils/formatters/ig-story-from-dynamo", ["exports", "@ember/utils", "later/models/ig-story"], function (_exports, _utils, _igStory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"later/models/ig-story"eaimeta@70e063a35619d71f
  /**
   * Converts a raw dynamo story into an igStory
   *
   * @method createIgStoryFromDynamo
   * @param {RawDynamoIgMedia} obj Raw dynamo instagram post
   * @param {SocialProfile} socialProfile The social profile for the story
   *
   * @returns {UntypedLaterModel<'IgStory'>} Returns an igStory
   */
  function createIgStoryFromDynamo(obj, socialProfile) {
    const attrs = {};
    attrs.timeCollected = Date.now();
    attrs.socialProfile = socialProfile;
    attrs.id = obj.id;
    attrs.createdTime = obj.created_time;
    attrs.type = obj.type;
    attrs.isStory = true;
    attrs.isDeleted = obj.is_deleted;
    attrs.imageUrl = obj.permanent_image_url || obj.thumbnail_url || obj.media_url;
    if (!(0, _utils.isNone)(obj.caption)) {
      attrs.caption = obj.caption;
    }

    // Note: Bugs LG-5675 & LG-5755, -1 value is coming from IG
    // Solution is to temporarily clear values
    if (!(0, _utils.isNone)(obj.exits)) {
      attrs.exits = obj.exits < 0 ? null : Number(obj.exits);
    }
    if (!(0, _utils.isNone)(obj.impressions)) {
      attrs.impressions = obj.impressions < 0 ? null : Number(obj.impressions);
    }
    if (!(0, _utils.isNone)(obj.reach)) {
      attrs.reach = obj.reach < 0 ? null : Number(obj.reach);
    }
    if (!(0, _utils.isNone)(obj.replies)) {
      attrs.replies = obj.replies < 0 ? null : Number(obj.replies);
    }
    if (!(0, _utils.isNone)(obj.taps_back)) {
      attrs.tapsBack = obj.taps_back < 0 ? null : Number(obj.taps_back);
    }
    if (!(0, _utils.isNone)(obj.taps_forward)) {
      attrs.tapsForward = obj.taps_forward < 0 ? null : Number(obj.taps_forward);
    }
    if (!(0, _utils.isNone)(obj.media_url)) {
      attrs.mediaUrl = obj.media_url;
    }
    if (!(0, _utils.isNone)(obj.thumbnail_url)) {
      attrs.thumbnailUrl = obj.thumbnail_url;
    }
    if (!(0, _utils.isNone)(obj.image_medium_url)) {
      attrs.imageMediumUrl = obj.image_medium_url;
    }
    return _igStory.default.create(attrs);
  }
  var _default = _exports.default = createIgStoryFromDynamo;
});